import { fetchOne } from '../../../../../packages/neb-api-client/src/patient-api-client';
import { openOverlayPatientInsuranceView } from '../../../../../packages/neb-app-layout/neb-open-overlay';
import { INSURANCE_LEVELS } from '../../../../../packages/neb-lit-components/src/utils/insurance-util';

const getInsuranceId = (
  insuranceLevel,
  { primaryInsuranceId, secondaryInsuranceId },
) =>
  insuranceLevel === INSURANCE_LEVELS.PRIMARY
    ? primaryInsuranceId
    : secondaryInsuranceId;

export default async ({ index, insuranceLevel, tableModel }) => {
  const { patientId } = tableModel[index];

  const insuranceId = getInsuranceId(insuranceLevel, tableModel[index]);

  const patientInfo = await fetchOne(patientId);

  return openOverlayPatientInsuranceView({
    patientId,
    patientInsurance: { id: insuranceId },
    patientInfo,
  });
};
